import { Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import { IntroductionButton, RemarkButton } from '@Components/IconButton';
import Introduction from '@Components/Introduction';
import Remark from '@Components/Remark';
import { useDisclosure } from '@hooks/useDisclosure';
import { useWatch } from 'react-hook-form';
import { useNatureOfBusinessForm } from '../NatureOfBusinessFormProvider';
import { INatureOfBusinessFormValues } from '../NatureOfBusinessFormProvider/types';

const NatureOfBusinessOverview = () => {
  const { getValues } = useNatureOfBusinessForm();
  const { introduction, remark } =
    getValues() ?? ({} as INatureOfBusinessFormValues);
  const [
    openIntroduction,
    { open: openIntroductionDialog, close: closeIntroduction },
  ] = useDisclosure(!!introduction);

  const [openRemark, { open: openRemarkDialog, close: closeRemark }] =
    useDisclosure(!!remark);

  const isCompletedTh =
    useWatch({
      name: 'completedSection.isCompletedTh',
    }) ?? false;
  const isCompletedEn =
    useWatch({
      name: 'completedSection.isCompletedTh',
    }) ?? false;

  return (
    <Flex p={2} flexDirection={'column'} bgcolor={'white'} gap={2}>
      <Flex gap={1}>
        <Typography fontWeight={700}>ลักษณะการประกอบธุรกิจ</Typography>
        <Flex gap={0.5} alignItems={'center'}>
          <IntroductionButton
            onClick={() => openIntroductionDialog()}
            disabled={isCompletedTh && isCompletedEn}
          />
          <RemarkButton
            onClick={() => openRemarkDialog()}
            disabled={isCompletedTh && isCompletedEn}
          />
        </Flex>
      </Flex>
      {openIntroduction && (
        <Introduction
          onDelete={closeIntroduction}
          topic="ลักษณะการประกอบธุรกิจ"
          setOpen={openIntroductionDialog}
          fieldPath="introduction"
          isCompletedTh={isCompletedTh}
          isCompletedEn={isCompletedEn}
        />
      )}
      {openRemark && (
        <Remark
          onDelete={closeRemark}
          topic="ลักษณะการประกอบธุรกิจ"
          setOpen={openRemarkDialog}
          fieldPath="remark"
          isCompletedTh={isCompletedTh}
          isCompletedEn={isCompletedEn}
        />
      )}
    </Flex>
  );
};

export default NatureOfBusinessOverview;
